import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { MAIN_SYSTEM_URL } from '../../config';
import './LoadingScreen.scss';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, profile, loading } = useAuth();

  // 未登入時跳回主系統
  useEffect(() => {
    if (!loading && !user) {
      console.log('🔄 未登入，跳轉回主系統登入頁');
      window.location.href = `${MAIN_SYSTEM_URL}/auth/login`;
    }
  }, [loading, user]);

  // 載入中顯示載入畫面
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <div className="loading-text">系統正在努力加載頁面中，請稍候...</div>
      </div>
    );
  }

  // 未登入，顯示跳轉中畫面（useEffect 會處理跳轉）
  if (!user) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <div className="loading-text">認證已過期，正在跳轉到登入頁...</div>
      </div>
    );
  }

  // 需要 Admin 權限但使用者不是 Admin
  if (requireAdmin && !['department_admin', 'super_admin'].includes(profile?.role)) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: '#666'
      }}>
        <h2>🚫 權限不足</h2>
        <p>您沒有權限存取此頁面</p>
        <button
          onClick={() => window.history.back()}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          返回
        </button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
